


import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {Timeline, TimelineLite} from "gsap";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";

export class NearWinView extends BaseView {

    private _layer:ScalableLayer;

    private _spineContainer:PIXI.Sprite;
    private _nearWinSpine:PIXI.spine.Spine;

    private _spineOmenContainers:PIXI.Sprite [];
    private _wildOmenSpine:PIXI.spine.Spine;


    private _testTl:Timeline | null;
    private _testToggle:boolean = true;

    constructor() {
        super();


        this._layer = StageManager.getLayer(GameConfig.instance.LAYERS.NEAR_WIN.name);
        this._layer.addChild(this);
    }

    initAnimations() {
        this._spineContainer = this.createNearWinSpine();
        this._spineContainer.visible = false;
        this._spineOmenContainers = this.createWildOmenSpine();

        this.addChild(this._spineContainer);
        //this.addChild(this._spineOmenContainer);

        //this.visible = false;
        //this.tmpDebugHandler();

        //this.hideWildOmens();
        //this.playWildOmenOnReel(4);
    }

    protected createNearWinSpine():PIXI.Sprite {
        const sprite:PIXI.Sprite = new PIXI.Sprite();

        this._nearWinSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("nearWin"));
        this._nearWinSpine.name =  "nearWinSpine";

        sprite.addChild(this._nearWinSpine);
        this._nearWinSpine.autoUpdate = true;

        sprite.anchor.set(0.5, 0.5);
        sprite.position.set(600, 500);

        this._nearWinSpine.stateData.setMix("NerWinScatterReel2", "NerWinScatterReel3", 0.01);
        this._nearWinSpine.stateData.setMix("NerWinScatterReel3", "NerWinScatterReel4", 0.01);

        return sprite;
    }

    protected createWildOmenSpine():PIXI.Sprite [] {
        const sprites:PIXI.Sprite [] = [];

        [0,1,2,3,4].forEach((value) => {
            const sprite:PIXI.Sprite = new PIXI.Sprite();
            this._wildOmenSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("wildOmen"));
            this._wildOmenSpine.name =  "wildOmenSpine" + value;
            //console.log(this._wildOmenSpine.spineData.animations);
            sprite.addChild(this._wildOmenSpine);
            this._wildOmenSpine.autoUpdate = true;
            //this._wildOmenSpine.state.setAnimation(0, "wildOmen1", true);
            //sprite.anchor.set.y(0.5, 0.5);

            const pos:number [] = Helper.getSymbolPositions(value, 0);
            sprite.position.set(pos[0] - 50, 500); // mid x: 600
            sprite.renderable = false;

            sprites.push(sprite);
            this.addChild(sprite);
        });

        return sprites;
    }

    private tmpDebugHandler():void {
        const ref = this;

        document.addEventListener("keydown", function(e) {
            var keyCode = e.keyCode;
            //console.log("KeyCode: " + keyCode);

            switch(keyCode) {
                case 48:
                    if(ref._testTl) {
                        ref._testTl.pause();
                        ref._testTl.kill();
                        ref._testTl = null;
                    }
                    ref._nearWinSpine.state.setEmptyAnimation(0, 0);
                    ref._spineContainer.visible = false;
                    ref._testToggle = !ref._testToggle;
                    break; // 0
                case 49:
                    if(ref._testToggle) {
                        ref.playOnReel(0);
                    }
                    else {

                    }
                    break; // 1
                case 50:
                    if(ref._testToggle) {
                        ref.playOnReel(1);
                    }
                    else {

                    }
                    break; // 2
                case 51:
                    if(ref._testToggle) {
                        ref.playOnReel(2);
                    }
                    else {

                    }
                    break; // 3
                case 52:
                    if(ref._testToggle) {
                        ref.playOnReel(3);
                    }
                    else {

                    }
                    break; // 4
                case 53:
                    if(ref._testToggle) {
                        ref.playOnReel(4);
                    }
                    break; // 1
            }
        }, false);
    }

    public addSlowmoStackedWildAttention():Timeline {
        const tl:Timeline = new TimelineLite();

        return tl;
    }

    public reset():void {
        if(this._testTl) {
            this._testTl.pause();
            this._testTl.kill();
            this._testTl = null;
        }
        this._nearWinSpine.state.setEmptyAnimation(0, 0);
        this._spineContainer.visible = false;
        //this._spineOmenContainer.visible = false;
    }

    public hideWildOmens():void {
        this._spineOmenContainers.forEach((container) => {
            //(<PIXI.spine.Spine> container.children[0]).state.setEmptyAnimation(0, 0);
            container.renderable = false;
        });
    }

    public playOnReel(reelId:number):Timeline {
        const tl:TimelineLite = new TimelineLite();

        if(reelId > -1 && reelId < 5) {
            switch(reelId) {
                case 0:
                    tl.add(() => {
                        this._spineContainer.visible = true;
                    });
                    tl.add(this.playNearWin("NerWinScatterReel1", true));
                    this._testTl = tl;
                    break;
                case 1:
                    tl.add(() => {
                        this._spineContainer.visible = true;
                    });
                    tl.add(this.playNearWin("NerWinScatterReel2", true));
                    this._testTl = tl;
                    break;
                case 2:
                    tl.add(() => {
                        this._spineContainer.visible = true;
                    });
                    tl.add(this.playNearWin("NerWinScatterReel3", true));
                    this._testTl = tl;
                    break;
                case 3:
                    tl.add(() => {
                        this._spineContainer.visible = true;
                    });
                    tl.add(this.playNearWin("NerWinScatterReel4", true));
                    this._testTl = tl;
                    break;
                case 4:
                    tl.add(() => {
                        this._spineContainer.visible = true;
                    });
                    tl.add(this.playNearWin("NerWinScatterReel5", true));
                    this._testTl = tl;
                    break;
            }
        }

        return tl;
    }

    public playWildOmenOnReel(reelId:number, hide:boolean = false):Timeline {
        const tl:TimelineLite = new TimelineLite();

        if(reelId > -1 && reelId < 5) {
            switch(reelId) {
                case 0:
                    tl.add(() => {
                        if(hide) {
                            this.hideWildOmens();
                        }
                        this._spineOmenContainers[0].renderable = true;
                    });
                    tl.add(this.playNearWin("wildOmen1", false, reelId));
                    this._testTl = tl;
                    break;
                case 1:
                    tl.add(() => {
                        if(hide) {
                            this.hideWildOmens();
                        }
                        this._spineOmenContainers[1].renderable = true;
                    });
                    tl.add(this.playNearWin("wildOmen1", false, reelId));
                    this._testTl = tl;
                    break;
                case 2:
                    tl.add(() => {
                        if(hide) {
                            this.hideWildOmens();
                        }
                        this._spineOmenContainers[2].renderable = true;
                    });
                    tl.add(this.playNearWin("wildOmen1", false, reelId));
                    this._testTl = tl;
                    break;
                case 3:
                    tl.add(() => {
                        if(hide) {
                            this.hideWildOmens();
                        }
                        this._spineOmenContainers[3].renderable = true;
                    });
                    tl.add(this.playNearWin("wildOmen1", false, reelId));
                    this._testTl = tl;
                    break;
                case 4:
                    tl.add(() => {
                        //this.hideWildOmens();
                        //this._spineOmenContainers[4].renderable = true;
                    });
                    //tl.add(this.playNearWin("wildOmen1", true, reelId));
                    this._testTl = tl;
                    break;
            }
        }

        return tl;
    }

    protected playNearWin(name:string, loop:boolean = false, reelId:number = -1):Timeline {
        const tl:TimelineLite = new TimelineLite();

        tl.add(() => {
            if(reelId > -1) {
                (<PIXI.spine.Spine> this._spineOmenContainers[reelId].children[0]).state.timeScale = 2;
                (<PIXI.spine.Spine> this._spineOmenContainers[reelId].children[0]).state.setAnimation(0, name, loop);
            }
            else {
                this._nearWinSpine.state.setAnimation(0, name, loop);
            }
        });

        return tl;
    }

    protected onResize(resizeData:IResizeData):void {

        // TODO: fix scaling 4:3 -> 16:9
        if(resizeData.orientation == Orientation.PORTRAIT) {

            this.position.set(-240, -143);
            this.scale.set(1, 1);
        }
        else {
            //this.position.set(175, 225);
            this.position.set(-170, 3);
            this.scale.set(0.87, 0.87);
        }

    }

    /*protected createOverlay(noNudge:boolean = false):Sprite {
        const sprite = new Sprite();

        this._walkerSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("wildWalker"));
        this._walkerSpine.name = "spine";
        sprite.addChild(this._walkerSpine);
        this._walkerSpine.autoUpdate = true;
        if(!noNudge) {
            this._walkerSpine.state.setAnimation(0, "X2", false);
        }
        else {
            this._walkerSpine.state.setAnimation(0, "X1Idle", false);
        }
        this._walkerSpine.y = 200;

        sprite.anchor.set(0.5, 0.165);
        sprite.position.set(Helper.getSymbolPositions(2, 0)[0], Helper.getSymbolPositions(2, 0)[1]);

        const mpSprite:Sprite = new Sprite(PIXI.Texture.WHITE);
        mpSprite.tint = 0x000000;
        mpSprite.name = "txtSprite";
        mpSprite.anchor.set(0.5, 0.5);
        mpSprite.width = sprite.width;
        mpSprite.height = sprite.height/4;
        mpSprite.y = 144 * 3;

        const mpText:PIXI.Text = new PIXI.Text("x2", HarlequinTextStyles.WALKER_MP);
        mpText.name = "text";
        mpText.anchor.set(0.5, 0.5);
        mpText.scale.set(0.25, 0.25);
        //mpSprite.addChild(mpText);
        this._mpText = mpText;
        this._mpSprite = mpSprite;

        sprite.addChild(mpSprite);
        sprite.visible = false;

        return sprite;
    }*/



}